export interface NormalizedPrice {
  amount: number;
  currency: string;
}

interface RawPrice {
  amount: number;
  currency_code?: string;
}

export function normalizePrice(
  price: RawPrice | number | undefined | null, 
  defaultCurrency = 'NOK'
): NormalizedPrice {
  if (!price) {
    return {
      amount: 0,
      currency: defaultCurrency
    };
  }

  const amount = typeof price === 'number' ? price : price.amount;
  const currency = typeof price === 'number' ? defaultCurrency : (price.currency_code || defaultCurrency);

  return {
    amount,
    currency
  };
}

export function normalizeTicketPrice(price: RawPrice | number | undefined | null): NormalizedPrice {
  return normalizePrice(price, 'NOK'); // Ticket prices are in kroner
}

export function normalizeEquipmentPrice(price: RawPrice | number | undefined | null): NormalizedPrice {
  return normalizePrice(price, 'NOK'); // Equipment prices are now converted to kroner at the source
}

// Seat prices are now always converted to kroner at the source
export function normalizeSeatPrice(price: number | undefined | null): NormalizedPrice {
  return normalizePrice(price ? { amount: price, currency_code: 'NOK' } : null, 'NOK');
}

export function formatNormalizedPrice(price: NormalizedPrice | null | undefined): string {
  if (!price || typeof price.amount !== 'number') {
    return '0,-';
  }
  return `${price.amount.toFixed(0)}${price.currency === 'NOK' ? ',-' : ` ${price.currency}`}`;
}
